(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["anchor-point"] && !Shopify.designMode) return;
  try {
    if (!window.anchorPointFloatingButtons) {
    window.anchorPointFloatingButtons = (() => {
      let updateRequested = false;

      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      function getHeaderHeight() {
        const headerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));

        return Number.isFinite(headerHeight) ? headerHeight : 0;
      }

      function getPairs() {
        return Array.from(document.querySelectorAll('.anchor-point[id]'))
          .map((anchor) => {
            const button = anchor.nextElementSibling;

            if (!(button instanceof HTMLButtonElement)) return null;
            if (!button.matches('[data-anchor-point-button]')) return null;
            if (button.dataset.anchorTarget !== anchor.id) return null;

            return { anchor, button };
          })
          .filter(Boolean);
      }

      function setButtonVisibility(button, isVisible) {
        if (isVisible) {
          if (button.hidden) {
            button.hidden = false;
            window.requestAnimationFrame(() => {
              if (!button.hidden) {
                button.classList.add('is-visible');
              }
            });

            return;
          }

          button.classList.add('is-visible');

          return;
        }

        button.classList.remove('is-visible');
        button.hidden = true;
      }

      function update() {
        const headerHeight = getHeaderHeight();
        const pairs = getPairs();
        let activePair;

        pairs.forEach((pair) => {
          if (pair.anchor.getBoundingClientRect().top <= headerHeight) {
            activePair = pair;
          }
        });

        pairs.forEach(({ button }) => setButtonVisibility(button, button === activePair?.button));
      }

      function requestUpdate() {
        if (updateRequested) return;

        updateRequested = true;

        window.requestAnimationFrame(() => {
          updateRequested = false;
          update();
        });
      }

      function handleClick(event) {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest('[data-anchor-point-button]');

        if (!(button instanceof HTMLButtonElement)) return;

        const target = document.getElementById(button.dataset.anchorTarget);

        if (!target) return;

        target.scrollIntoView({
          behavior: motionQuery.matches ? 'auto' : 'smooth',
          block: 'start',
        });
      }

      document.addEventListener('click', handleClick);
      document.addEventListener('scroll', requestUpdate, { passive: true });
      document.addEventListener('shopify:block:select', requestUpdate);
      document.addEventListener('shopify:section:load', requestUpdate);
      document.addEventListener('shopify:section:unload', requestUpdate);
      window.addEventListener('hashchange', requestUpdate);
      window.addEventListener('load', requestUpdate);
      window.addEventListener('resize', requestUpdate);

      requestUpdate();

      return { update: requestUpdate };
    })();
  } else {
    window.anchorPointFloatingButtons.update();
  }
  } catch(e) { console.error(e); }
})();

})();
